import { action } from '@ember/object';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';

import ClientsBaseController from 'webapp/controllers/clients/base';

import type Space from 'webapp/models-custom/space';

export default class ClientsAccountsController extends ClientsBaseController {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('billing') declare billingService: Service.Billing;

	override trackingOrigin = 'clients';

	@action
	override createNewClient() {
		if (this.currentUserService.handleDemo()) {
			return;
		}

		if (this.billingService.checkIfCan(BillingFeature.CLIENTS, true)) {
			this.navigationService.transitionToRoute('clients.accounts.new');
		}
	}

	@action
	deleteClient(client: Space) {
		client
			.delete()
			.then(() => {
				this.analyticsService.event(TrackingEvent.CLIENT_DELETED, {
					deletedClientId: client.id,
					origin: this.trackingOrigin,
				});
				this.infolayerService.ok('Account deleted!');
			})
			.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
	}
}
